import { render } from "./CustomerCategorie.vue?vue&type=template&id=53ad3355&scoped=true"
import script from "./CustomerCategorie.vue?vue&type=script&lang=js"
export * from "./CustomerCategorie.vue?vue&type=script&lang=js"

import "./CustomerCategorie.vue?vue&type=style&index=0&id=53ad3355&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ad3355"]])

export default __exports__